import LoadingIcon from './LoadingIcon/LoadingIcon';
import {withWindowSize} from './higherOrderComponents';

export {
  LoadingIcon,
  withWindowSize,
}
